<template>
  <v-app id="set-password-app" class="setPassword">
    <div class="passwordContainer">
      <img
        class="logo"
        :src="darkMode?brandingService.getLoginDarkLogoUrl():brandingService.getLoginLogoUrl()"
        alt="brandingService.getLoginLogoAlt()"
      />
      <section class="middle form" v-if="!submitted">
        <h1 class="password-title">Set Password</h1>
        <PasswordEntry @password-updated="updatePassword"></PasswordEntry>
        <button
          class="btn btn-primary submit"
          :disabled="validateFields()"
          @click="submitPassword"
        >Submit</button>
      </section>
      <section class="middle submitted" v-if="submitted">
        <div v-if="submitError">
          <h1 class="password-title">Something Went Wrong</h1>
          <p>There was an error processing your request.</p>
          <p>Please contact <a :href="getSupportContactUrl()">support</a> for further assistance with this issue.</p>
        </div>
        <div v-if="!submitError">
          <h1 class="password-title">All Set</h1>
          <p>Click on the link below to log into WXP Collaboration.</p>
          <a href="/">Log In</a>
        </div>
      </section>
      <p class="copywrite">© {{currentYear}} HP Inc.
          <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
          <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
          and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
      </p>
    </div>
  </v-app>
</template>

<script>
  import BrandingService from '../../../../services/branding.service';
  import ConfigService from '../../../../services/config.service';
  import PasswordEntry from '../../../../components/password-setup-view/PasswordEntry.component.vue';
  import 'whatwg-fetch';
  import moment from "moment-timezone";

  export default {
    name: 'set-password',
    props: {
      token: {
        type: String,
        default: '',
      },
    },
    components: {
      PasswordEntry
    },
    data: function() {
      const isDarkMode = document.body.classList.contains('dark');
      return {
        brandingService: BrandingService,
        darkMode: isDarkMode,
        password: '',
        submitted: false,
        submitError: '',
        currentYear: moment().year(),
      };
    },
    created: function() {
      console.log(this);
    },
    methods: {
      getSupportContactUrl: function() {
        return this.brandingService.getSupportContactUrl();
      },
      updatePassword: function(newPassword) {
        this.password = newPassword;
      },
      validateFields: function() {
        if (this.password.length >= ConfigService.getInstance().getPasswordMinimumLength()) {
          return false;
        }
        return true;
      },
      submitPassword: function() {
        let self = this;
        ConfigService.getInstance().getAdminService().then(function (serviceUrl) {
          window.fetch(serviceUrl + '/userreg/api/v1/user_password', {
            method: 'PUT',
            body: JSON.stringify({
              password: self.password,
              token: self.token,
            }),
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          }).then((result)  => {
            if (!result.ok) {
              self.submitError = result.statusText;
            }
            self.submitted = true;
          });
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .setPassword {
    .passwordContainer {
      width: 50%;
      margin: auto;
      margin-top: 50px;
      text-align: center;
      background-color: var(--panel-background);
      .logo {
        height: 190px;
        margin: auto;
        padding-top: 50px;
        padding-bottom: 50px;
      }
      .middle {
        height: 450px;
        max-width: 465px;
        margin: auto;
        .password-title {
          color: var(--text-color);
          text-align: center;
          font-family: var(--font-family);
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-bottom: 30px;
        }
        .password-field {
          > .v-input__control > .v-input__slot > .v-text-field__slot {
            margin-top: -10px;
          }
          fieldset {
            height: 50px;
            border-radius: var(--text-input-border-radius);
            border-color: var(--stroke-decorative-default);
          }
        }
        .submit {
          height: 50px;
          width: 100%;
        }
      }
    }
  }
</style>
<style>
.setPassword .setPasswordContainer .set-password-content .password-field .v-label {
  margin-top: 10px;
}
</style>
